import { render } from "./sjtj.vue?vue&type=template&id=5ab1206c&scoped=true"
import script from "./sjtj.vue?vue&type=script&lang=js"
export * from "./sjtj.vue?vue&type=script&lang=js"

import "./sjtj.vue?vue&type=style&index=0&id=5ab1206c&scoped=true&lang=css"

import exportComponent from "D:\\智诚大数据\\禁种铲毒\\禁种铲毒平台\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab1206c"]])

export default __exports__